export default __webpack_public_path__ + "static/media/linkedinWhite.de2a654e.svg";